import { render, staticRenderFns } from "./ListLayout.vue?vue&type=template&id=28ba6fda&"
import script from "./ListLayout.vue?vue&type=script&lang=js&"
export * from "./ListLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports